import { useProductContractHandoff } from "@/api/services/admin/product-contract";
import { LoadingScreen } from "@/components/elements/Loading/Loading";
import { TopPage } from "@/components/elements/TopPage";
import { RegisterSupportOrganizationForm } from "@/features/rso/components/RegisterSupportOrganizationForm";
import { AppRoutes } from "@/routes/config";
import { Stack } from "@mui/material";
import { FC } from "react";
import { Navigate } from "react-router-dom";

type TRsoCreatePageProps = {};

export const RsoCreatePage: FC<TRsoCreatePageProps> = () => {
  const { canCreateRso, isLoading } = useProductContractHandoff();

  if (isLoading) return <LoadingScreen />;
  if (!canCreateRso) return <Navigate to={AppRoutes.pageNotFound} replace />;

  return (
    <Stack gap={4} height="100%">
      <TopPage title="登録支援機関の追加" description="機関の基本情報を入力して追加しましょう。" enablePageBack={false} />
      <RegisterSupportOrganizationForm />
    </Stack>
  );
};
